import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppAuth } from '@/hooks/useAppAuth';
import { useUserRoles } from '@/hooks/useUserRoles';

/**
 * Route guard for pages that belong to the tenant proper — Admin, Builder or
 * ReadOnly — and are hidden from ReadOnly_Partner, who is an external dashboard
 * viewer.
 *
 * Redirects rather than rendering nothing, so a partner following a stale link
 * lands somewhere useful instead of on a blank page. Waits for the user before
 * deciding: roles arrive asynchronously, and redirecting on an empty role list
 * would bounce everyone on a cold load.
 */
export function RequireTenantMember({ children }: PropsWithChildren) {
  const { user } = useAppAuth();
  const { canViewDataManagement } = useUserRoles();

  if (!user) return null;
  if (!canViewDataManagement) return <Navigate to="/" replace />;

  return <>{children}</>;
}
